import * as THREE from 'three';

import { UIButton, UIPanel, UIText } from './libs/ui.js';
import { UIBoolean } from './libs/ui.three.js';
import { DIALOG_SCREEN_STATES } from './Config.EJX.js';

function MenubarStatus( editor ) {

	const strings = editor.strings;
	const signals = editor.signals;
	const config = editor.config;

	const container = new UIPanel();
	container.setClass( 'menu right' );

	const autosave = new UIBoolean( editor.config.getKey( 'autosave' ), strings.getKey( 'menubar/status/autosave' ) );
	autosave.text.setColor( '#888' );
	autosave.onChange( function () {

		const value = this.getValue();

		editor.config.setKey( 'autosave', value );

		if ( value === true ) {

			editor.signals.sceneGraphChanged.dispatch();

		}

	} );
	container.add( autosave );

	editor.signals.localSaveStarted.add( function () {

		autosave.text.setTextDecoration( 'underline' );

	} );

	editor.signals.localSaveFinished.add( function () {

		autosave.text.setTextDecoration( 'none' );

	} );

	const version = new UIText( 'r' + THREE.REVISION );
	version.setClass( 'title' );
	version.setOpacity( 0.5 );
	container.add( version );

	return container;

}

export { MenubarStatus };
